import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import HeroSection from 'modules/product_updates/components/HeroSection'
import ListSection from 'modules/product_updates/components/ListSection'
import ModuleFilters from 'modules/product_updates/components/ModuleFilters'

type Props = {
  upsellOrigin: string | null
  canSeeSubscribeButton: boolean
  canSeeUpsellButton: boolean
  canSeeShareButton: boolean
}

const NewLayoutContent = ({
  upsellOrigin,
  canSeeSubscribeButton,
  canSeeUpsellButton,
  canSeeShareButton,
}: Props) => {
  const [isLaunched, setIsLaunched] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedModule, setSelectedModule] = useState<string | undefined>(
    searchParams.get('module') ?? undefined
  )

  return (
    <Box gap="s40">
      <HeroSection />

      <ModuleFilters
        selectedModule={selectedModule}
        setSelectedModule={setSelectedModule}
        onModuleChange={(e) => {
          if (!e) {
            searchParams.delete('module')
            setSearchParams(searchParams)
            setSelectedModule(undefined)
          } else {
            searchParams.set('module', String(e))
            setSearchParams(searchParams)
            setSelectedModule(e)
          }
        }}
        isLaunched={isLaunched}
        setIsLaunched={setIsLaunched}
        canSeeSubscribeButton={canSeeSubscribeButton}
        canSeeUpsellButton={canSeeUpsellButton}
        canSeeShareButton={canSeeShareButton}
        upsellOrigin={upsellOrigin}
      />
      <ListSection selectedModule={selectedModule} isLaunched={isLaunched} />
    </Box>
  )
}

export default NewLayoutContent
